import React, { useContext, useState, useEffect } from "react";
import { Toast, ToastBody, ToastHeader } from "reactstrap";
import classnames from "classnames";
import { ToastContext, ToastContextDispatch } from "Context/CommonContext";
const ToastMessage = () => {
  let customClass = "";
  const useToast = useContext<any>(ToastContext);
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const [isOpenToast, setIsOpenToast] = useState<any>(false);
  useEffect(() => {
    if (useToast.isOpen) {
      setIsOpenToast(true);
      setTimeout(() => {
        closeToast();
      }, 3000);
    }
  }, [useToast]);

  const closeToast = () => {
    ToastDispatch({
      isOpen: false,
      type: useToast.type,
      message: "",
      isNotificationType: false,
      secondaryMessage: "",
    });
    setIsOpenToast(false);
  };
  let iconClass;
  if (useToast.type === "Success") {
    customClass = "successToastStyle";
    iconClass = "fa fa-thumbs-up";
  } else if (useToast.type === "Error") {
    customClass = "errorToastStyle";
    iconClass = "fa fa-exclamation-circle";
  } else if (useToast.type === "Warning") {
    customClass = "warningToastStyle";
    iconClass = "fa fa-exclamation-circle";
  } else if (useToast.type === "Secondary") {
    customClass = "secondaryToastStyle";
    iconClass = "fa fa-thumbs-up";
  } else if (useToast.type === "Info") {
    customClass = "infoToastStyle";
  } else {
    customClass = "primaryToastStyle";
    iconClass = "fa fa-thumbs-up";
  }

  return (
    <Toast
      className={classnames("toastPostion", customClass)}
      isOpen={isOpenToast}
      fade={true}
    >
      <ToastHeader
        icon={
          useToast.isNotificationType ? (
            <i className="fa fa-bell"></i>
          ) : (
            <i className={iconClass}></i>
          )
        }
        close={
          <span className="ml-2" onClick={() => closeToast()}>
            x
          </span>
        }
        className={classnames("toastHeaderStyle", customClass)}
        toggle={() => closeToast()}
      >
        {useToast.message}
      </ToastHeader>
      {useToast.isNotificationType && (
        <ToastBody className={classnames("toastBodyStyle", customClass)}>
          {useToast.secondaryMessage}
        </ToastBody>
      )}
    </Toast>
  );
};
export default ToastMessage;
